import { Component } from '@angular/core';
import { NbSidebarService } from '@nebular/theme';
import { Configuration } from 'app/models/configuration/configuration';
import { SiteSettings } from 'app/pages/settings/settings-page/site-settings';
import { ConfigurationService } from 'app/services/configurations/configurations.service';

@Component({
  selector: 'ultra-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout>
      <nb-layout-header fixed [style.background-color]="theme_color">
        <ultra-header></ultra-header>
      </nb-layout-header>

      <nb-sidebar state="compacted" class="menu-sidebar" tag="menu-sidebar" responsive start>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column (click)="hideSidebar()">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ultra-footer></ultra-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent {

  theme_color: string;
  siteSettings = SiteSettings.getInstance();

  constructor(private sidebarService: NbSidebarService, private service: ConfigurationService) {
    this._loadConfig();
  }

  _loadConfig(){
    let config = this.siteSettings.getConfiguration();

    if (config != null && config != undefined) {
      this.theme_color = config.themeColor;
    } else {
      this._loadConfigServer();
    }
  }

  _loadConfigServer(): void {
    this.service.getConfigurations().subscribe((value) => {
      this.siteSettings.setConfiguration(Configuration.fromJson(value.data));
      this._loadConfig();
    });
  }

  hideSidebar() {
    this.sidebarService.collapse('menu-sidebar');
  }
}
